export enum BlockBQueries {
  DemandDriverChart = 'demandDriverChart',
  DemandDriverTable = 'demandDriverTable',
}
